import { zetApi } from '@zet/network'

import {
  ICustomerCount,
  ILeadCount,
  ITruecallerAuthDetails,
  IZetUserInfo,
  UserContext,
} from './types'

export async function getCustomerCount() {
  const { data } = await zetApi.get<ICustomerCount>(
    'customer/getCustomerCount/v2'
  )
  return data?.data
}

export async function getLeadCount() {
  const { data } = await zetApi.get<ILeadCount>('userForm/getLeadCount/v2')
  return data?.data
}

export async function getUserSummary() {
  const { data } = await zetApi.get<IZetUserInfo>('user/summary')
  return data?.data
}

export async function getCreditScoreUrl() {
  const { data } = await zetApi.get('public/customer/generateCreditReport/link')
  return data
}

export async function updateUserProfile(user: UserContext) {
  try {
    const response = await zetApi.post('user/edit/zetUser', user)
    return response?.data
  } catch (error) {
    console.log('ERROR', error)
    throw error
  }
}

export async function updateFreshchatRestoreTokenId(restoreId: string) {
  try {
    const response = await zetApi.put('user/updateFreshChatId', restoreId)
    return response?.data
  } catch (error) {
    console.log('ERROR', error)
    throw error
  }
}

export async function updateEmailId(email: string) {
  try {
    const response = await zetApi.post(`user/addEmail?email=${email}`)
    if (response?.data?.error && response?.data?.error.code === 2034) {
      throw response?.data?.error
    }
    return response?.data
  } catch (error) {
    console.log('ERROR', error)
    throw error
  }
}

export async function updateAppOpenCount() {
  try {
    const response = await zetApi.post(`user/activity/app-open-count`)
    return response?.data
  } catch (error) {
    console.log('ERROR', error)
    throw error
  }
}

export async function getUserAddCustomerQRCode() {
  const { data } = await zetApi.get('/user/add-customer-qr')
  return data
}

export async function signupViaTruecaller(authDetails: ITruecallerAuthDetails) {
  try {
    const response = await zetApi.post('/signup/via-truecaller/v1', authDetails)
    return response?.data
  } catch (error) {
    console.log('ERROR', error)
    throw error
  }
}
